import type { Message } from 'wot-design-uni/components/wd-message-box/types';
import type { Toast, ToastLoadingType } from 'wot-design-uni/components/wd-toast/types';
import { useMessage, useToast } from 'wot-design-uni';

let _toast: Toast | null = null;
let _message: Message | null = null;

export function setupModal(): void {
  _toast = useToast();
  _message = useMessage();
}

export async function confirm(title: string, content: string, okText?: string, cancelText?: string): Promise<'confirm' | 'cancel'> {
  return new Promise((resolve): void => {
    _message.confirm({
      title,
      msg: content,
      confirmButtonText: okText || '确定',
      cancelButtonText: cancelText || '取消',
    }).then(() => {
      resolve('confirm');
    }).catch(() => {
      resolve('cancel');
    });
  });
}

export async function info(title: string, content: string): Promise<void> {
  return new Promise((resolve): void => {
    _message.alert({
      title,
      msg: content,
    }).then(() => {
      resolve();
    });
  });
}

export async function success(title: string, content: string): Promise<void> {
  return new Promise((resolve): void => {
    _message.prompt({
      title,
      msg: content,
    }).then(() => {
      resolve();
    });
  });
}

export async function error(title: string, content: string): Promise<void> {
  return new Promise((resolve): void => {
    _message.show({
      title,
      msg: content,
    }).then(() => {
      resolve();
    });
  });
}

export async function warning(title: string, content: string): Promise<void> {
  return new Promise((resolve): void => {
    _message.show({
      title,
      msg: content,
    }).then(() => {
      resolve();
    });
  });
}

export function msg(content: string, type: 'success' | 'error' | 'warning' | 'info' = 'success') {
  switch (type) {
    case 'success':
      _toast!.success(content);
      break;
    case 'error':
      _toast!.error(content);
      break;
    case 'warning':
      _toast!.warning(content);
      break;
    case 'info':
      _toast!.info(content);
      break;
  }
}

export function showLoading(msg: string = '', loadingType: ToastLoadingType = 'spinner') {
  // _toast!.loading({
  //   msg,
  //   loadingType,
  //   duration: 0,
  // });
  hideLoading();
  uni.showLoading({
    title: msg,
    mask: true,
  });
  setTimeout(() => {
    hideLoading();
  }, 20000);
}

export function hideLoading() {
  // _toast!.close();
  uni.hideLoading();
}

export async function prompt(data: { title: string, msg?: string, inputValue?: string, placeholder?: string }) {
  return _message.prompt(data);
}
